import React, { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';

import { useHttpGetGatewayKpis } from '../../hooks';
import FleetHealthCards from './FleetHealthCards';
import AsyncSection from './AsyncSection';
import { lastCompleteHourWindow } from './gatewayHealth';

const formatHour = value => new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

// Fleet-health summary at the top of the Gateways overview page. Fixed to the last
// complete hour (the at-a-glance "how is the fleet right now" view — one report per
// gateway, nothing averaged away); longer ranges + the alarm breakdown live on the
// dedicated Fleet health page.
//
// The parent can pass its own `from`/`to` so the cards and its bucket filter share one
// window (the overview page does this — the filtered table must count what the clicked
// card counted). `selectedBuckets`/`onToggleBucket` are forwarded to the cards.
const GatewayKpis = ({ from, to, selectedBuckets, onToggleBucket }) => {
    // Computed once on mount so the fallback window (and the fetch) is stable.
    const [defaultWindow] = useState(() => lastCompleteHourWindow());
    const win = from && to ? { from, to } : defaultWindow;

    const { overview, isReady, error } = useHttpGetGatewayKpis(win.from, win.to);
    const total = overview?.total ?? 0;

    // The exact hour behind "last hour", in the operator's local time — right after the
    // hour turns it is the hour before last (see lastCompleteHourWindow).
    const hourLabel = `${formatHour(win.from)}–${formatHour(win.to)}`;

    return (
        <section className="gateways-overview__kpis">
            <div className="gateways-overview__kpis-header">
                <h2 className="gateways-overview__kpis-title">
                    Fleet health{' '}
                    <span className="gateways-overview__kpis-subtitle" title={hourLabel}>
                        · last hour
                    </span>
                </h2>
                <Link className="gateways-overview__kpis-link" to="/gateways/health">
                    View fleet health &rarr;
                </Link>
            </div>
            <AsyncSection
                isReady={isReady}
                error={error}
                isEmpty={total === 0}
                errorText="Could not load gateway KPIs."
                emptyText={`No gateway health data for ${hourLabel}.`}
            >
                <FleetHealthCards overview={overview} selectedBuckets={selectedBuckets} onToggleBucket={onToggleBucket} />
            </AsyncSection>
        </section>
    );
};

export default GatewayKpis;
